import './upload-logo.component.scss';

export default {
  group: 'form-group',
  clearLogoButton: 'btn btn-default clear-logo-btn',
  heading: ''
};
